import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
      this.$button = this.$('button')[0]
      this.$label = this.$('label')[0]
      const initialState = this.getData('active') == 'true' ? true : false
      this.setInitialState(initialState)
      this.bindEvents()
    }

    bindEvents() {
      this.onSubmitBind = this.onSubmit.bind(this)
      this.el.addEventListener('submit', this.onSubmitBind)
    }

    unbindEvents() {
      this.el.removeEventListener('submit', this.onSubmitBind)
    }

    onSubmit(e) {
      e.preventDefault()

      // Call API here
        const form = e.target
        const formUrl = form.action
        const formData = new FormData(form);
        const controller = new AbortController();

        fetch(formUrl, {
            method: form.method,
            body: formData,
            signal: controller.signal
        }).then(response => {
            return response.json()
        }).then(response => {
            if (response.success) {
                this.isBookmarked = !this.isBookmarked
                this.toggleBookmarkClass();
            }
        });
    }

    setInitialState(state = false) {
      this.isBookmarked = state
      this.toggleBookmarkClass()
    }

    toggleBookmarkClass() {
      if (this.isBookmarked) {
        this.$button.classList.add('is-bookmarked')
        this.$label.innerHTML = this.getData('label-active')
      } else {
        this.$button.classList.remove('is-bookmarked')
        this.$label.innerHTML = this.getData('label-inactive')
      }
    }

    destroy() {
      this.unbindEvents()

      if (this.app) {
        this.app.$destroy();
      }
    }
}
